import Vue from 'vue';
const resource = '/itemsuppliers';

export default {
  updatePrice(payload) {
    return Vue.prototype.$axiosMainClient.put(
      `${resource}/updateprice`,
      payload
    );
  },
  getByItem(idPublic) {
    return Vue.prototype.$axiosMainClient.get(`items/${idPublic}${resource}`);
  },
  getBySupplier(idPublic) {
    return Vue.prototype.$axiosMainClient.get(
      `suppliers/${idPublic}${resource}`
    );
  },
};
